var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.7 16c0-8.44996 6.85004-15.3 15.3-15.3 8.45 0 15.3 6.85004 15.3 15.3 0 8.45-6.85 15.3-15.3 15.3-8.44996 0-15.3-6.85-15.3-15.3z",
    stroke: "#3f59dd",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.6667 10c0-.36819-.2985-.66667-.6667-.66667s-.6667.29848-.6667.66667zm-1.1381 12.4714c.2603.2604.6825.2604.9428 0l4.2426-4.2426c.2604-.2604.2604-.6825 0-.9428-.2603-.2604-.6824-.2604-.9428 0l-3.7712 3.7712-3.7712-3.7712c-.2604-.2604-.6825-.2604-.9428 0-.2604.2603-.2604.6824 0 .9428zm-.1953-12.4714v12h1.3334v-12z",
    fill: "#3f59dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.58c9d7fff950640600f46a9bca577263.svg";
export { ForwardRef as ReactComponent };